import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "../../../App";
import { connect } from "react-redux";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { Button, Modal } from "react-bootstrap";
import CandidateRemove from "./CandidateRemove";

const UnAssignCandidate = ({
  showAssignCandidateModal,
  setShowAssignCandidateModal,
  selectedRequirement,
}) => {
  return (
    <Modal
      className="fade bd-example-modal-lg"
      show={showAssignCandidateModal}
      size="lg"
      onHide={() => setShowAssignCandidateModal(false)}
    >
      <Modal.Header>
        <Modal.Title>
          Remove Candidates From {selectedRequirement?.jobTitle} (
          {selectedRequirement?.jobID})
        </Modal.Title>
        <Button
          variant=""
          className="btn-close"
          onClick={() => setShowAssignCandidateModal(false)}
        ></Button>
      </Modal.Header>
      <Modal.Body>
        <CandidateRemove
          selectedRequirement={selectedRequirement}
          setShowAssignCandidateModal={setShowAssignCandidateModal}
        />
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
  };
};

export default withRouter(connect(mapStateToProps)(UnAssignCandidate));
